module.exports = __webpack_public_path__ + "img/shijingtu.7795465b.webp";